import script from "./EditMiddleMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditMiddleMenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./EditMiddleMenuItem.vue?vue&type=style&index=0&id=2b99efa6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b99efa6"]])

export default __exports__